/* eslint @typescript-eslint/camelcase: 0 */
import { request } from "api";

export type AccessTokenResponse = {
  accessToken: string;
};

export type VerifyApiResponse = {
  id: number;
  loginId: string;
  agency?: {
    id: number;
    name: string;
    createdAt: string;
    updatedAt: string;
  };
  developer?: {
    id: number;
    name: string;
    createdAt: string;
    updatedAt: string;
  };
  createdAt: string;
  updatedAt: string;
};

export type AccessTokenParams = {
  loginId?: string;
  password?: string;
};

export type PasswordParams = {
  currentPassword?: string;
  password?: string;
};

export class Api {
  public static accessToken(params: AccessTokenParams) {
    return request.post<AccessTokenResponse>("/user/access_token", params);
  }

  public static verify() {
    return request.get<VerifyApiResponse>("/user/verify");
  }

  public static password(params: PasswordParams) {
    return request.post("/user/password", params);
  }
}
